/**
 * Inverse of `screenToCanvas` (TASK-238.1). Converts a point from
 * unscaled canvas coordinates (`SchemaTapGrid.origin` / `Station.x, y`)
 * to physical screen pixels.
 *
 * Frontend convention (matches Android): `offsetX/Y` refs hold unscaled
 * canvas-space offsets. Pan is applied as `offsetX += distanceX / zoom`.
 * Forward: `screen = (canvas - pan) * zoom`.
 *
 * Keep in sync with Android `CanvasToScreen` (same formula) and iOS
 * `CanvasToScreen` (different formula — scaled contentOffset). See
 * spec §6.
 */
export function canvasToScreen(
  canvasX: number,
  canvasY: number,
  panX: number,
  panY: number,
  zoom: number,
): { x: number; y: number } {
  if (zoom <= 0) return { x: 0, y: 0 }
  return {
    x: (canvasX - panX) * zoom,
    y: (canvasY - panY) * zoom,
  }
}
